import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d473772"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "badge"
}
const _hoisted_2 = { class: "order-container" }
const _hoisted_3 = { class: "search-bar" }
const _hoisted_4 = { class: "search-bar-content" }
const _hoisted_5 = {
  key: 0,
  class: "order-list"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onUpdate:modelValue", "checked", "id"]
const _hoisted_8 = {
  key: 1,
  class: "weui-icon-checked"
}
const _hoisted_9 = ["for"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "item mini" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 创建时间 ", -1))
const _hoisted_13 = { class: "description" }
const _hoisted_14 = { class: "item large" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 包裹单号 ", -1))
const _hoisted_16 = { class: "description" }
const _hoisted_17 = { class: "item large" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 国内快递单号 ", -1))
const _hoisted_19 = {
  key: 0,
  class: "description"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "footer" }
const _hoisted_22 = { class: "item normal" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 包裹运费 ", -1))
const _hoisted_24 = { class: "price" }
const _hoisted_25 = { class: "ctrl" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  class: "package-attr-info"
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "icon" }
const _hoisted_31 = {
  key: 1,
  class: "empty-order"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tips" }, " 当前无寄包裹历史，先去寄个包裹吧 ", -1))
const _hoisted_33 = {
  key: 1,
  class: "unlogin"
}
const _hoisted_34 = { class: "footer-bar" }
const _hoisted_35 = ["checked"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "weui-icon-checked" }, null, -1))
const _hoisted_37 = { class: "bar-price" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "合计", -1))
const _hoisted_39 = { class: "price" }
const _hoisted_40 = {
  key: 1,
  class: "g-modal is-center logistics-code"
}
const _hoisted_41 = { class: "g-modal-body" }
const _hoisted_42 = { class: "modal-content" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "添加快递单号", -1))
const _hoisted_44 = { class: "logistics-code-input" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_PageContainer = _resolveComponent("PageContainer")!
  const _component_Payment = _resolveComponent("Payment")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["order-list-wrapper", { 'large-padding-top': _ctx.isLargeScreen }]),
    id: "orderListContainer"
  }, [
    _createElementVNode("div", {
      id: "orderNavbar",
      class: _normalizeClass(["navbar g-fixed", { 'large-top': _ctx.isLargeScreen }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["navbar-item", { active: _ctx.curNavKey === 'unpaid' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleTab('unpaid')))
      }, [
        _createTextVNode(" 待支付 "),
        (_ctx.unpaidTotal > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.unpaidTotal), 1))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["navbar-item", { active: _ctx.curNavKey === 'paid' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleTab('paid')))
      }, " 已支付 ", 2),
      _createElementVNode("div", {
        class: _normalizeClass(["navbar-item", { active: _ctx.curNavKey === 'all' }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleTab('all')))
      }, " 全部 ", 2)
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isLogin)
        ? (_openBlock(), _createBlock(_component_PageContainer, {
            key: 0,
            class: "container",
            onNextPage: _ctx.getPageData
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_Icon, {
                    class: "search-icon",
                    icon: "icon_search"
                  }),
                  _withDirectives(_createElementVNode("input", {
                    class: "search-input",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.keyword) = $event)),
                    onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.keywordChange && _ctx.keywordChange(...args))),
                    "confirm-type": "search",
                    type: "text",
                    "placeholder-class": "search-input-placeholder",
                    placeholder: "查找包裹单号、入仓单号"
                  }, null, 544), [
                    [_vModelText, _ctx.keyword]
                  ]),
                  _createElementVNode("div", {
                    class: "clear",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)))
                  }, [
                    _createVNode(_component_Icon, { icon: "btn_cancel" })
                  ])
                ])
              ]),
              (_ctx.packageList.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packageList, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "order-item weui-cells_checkbox",
                        "wx:key": "id",
                        key: item.id,
                        onClick: ($event: any) => (_ctx.selectPackage(item))
                      }, [
                        (_ctx.curNavKey === 'unpaid')
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              type: "checkbox",
                              class: "g-checkbox checkbox weui-check",
                              "onUpdate:modelValue": ($event: any) => ((item.checked) = $event),
                              checked: item.checked,
                              id: item.id
                            }, null, 8, _hoisted_7)), [
                              [_vModelCheckbox, item.checked]
                            ])
                          : _createCommentVNode("", true),
                        (_ctx.curNavKey === 'unpaid')
                          ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                          : _createCommentVNode("", true),
                        _createElementVNode("label", {
                          for: item.id,
                          class: _normalizeClass(["g-card order-item-content", [
                { unpayed: item.status_pay == '2' && item.price },
                { delivered: item.status_pay == '1' },
              ]])
                        }, [
                          (item.id)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "",
                                onClick: _withModifiers(($event: any) => (_ctx.toDetail(item.id)), ["stop"])
                              }, [
                                _createElementVNode("div", _hoisted_11, [
                                  _hoisted_12,
                                  _createElementVNode("span", _hoisted_13, _toDisplayString(item['created']), 1)
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                  _hoisted_15,
                                  _createElementVNode("span", _hoisted_16, _toDisplayString(item.package_num), 1)
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                  _hoisted_18,
                                  (item.logistics_code || item.status_pay == 1)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(item.logistics_code || '-'), 1))
                                    : (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        onClick: _withModifiers(($event: any) => (_ctx.openLogisticsModal(item)), ["stop"]),
                                        class: "g-button g-button-primary g-button-plain"
                                      }, " 立即填写 ", 8, _hoisted_20))
                                ]),
                                _createElementVNode("div", _hoisted_21, [
                                  _createElementVNode("div", _hoisted_22, [
                                    _hoisted_23,
                                    _createElementVNode("span", _hoisted_24, _toDisplayString(item.price !== null ? '￥' + item.price : '等待仓库操作'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_25, [
                                    (item.status_pay === 2 && item.price)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          size: "mini",
                                          "hover-class": "hover",
                                          onClick: _withModifiers(($event: any) => (_ctx.startPay(item.id)), ["stop"]),
                                          class: "g-button g-button-danger-plain"
                                        }, " 立即支付 ", 8, _hoisted_26))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                (item.package_attr_total > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                      _createElementVNode("div", null, [
                                        (item.status_pay === 2)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, " 当前已作业" + _toDisplayString(item.package_attr_total) + "个包裹 ", 1))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_29, " 共计" + _toDisplayString(item.package_attr_total) + "个包裹 ", 1))
                                      ]),
                                      _createElementVNode("div", _hoisted_30, [
                                        _createVNode(_component_Icon, { icon: "btn_arrow_right" })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_10))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_9)
                      ], 8, _hoisted_6))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("button", {
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.navOrder && _ctx.navOrder(...args))),
                      "hover-class": "hover",
                      class: "g-button g-button-primary"
                    }, " 寄包裹 ")
                  ]))
            ]),
            _: 1
          }, 8, ["onNextPage"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createElementVNode("button", {
              class: "g-button g-button-primary link",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.navLogin && _ctx.navLogin(...args)))
            }, _toDisplayString(_ctx.$t('登录查看个人包裹列表')), 1)
          ]))
    ]),
    (_ctx.curNavKey == 'unpaid')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["footer-ctrl", { 'footer-ctrl-bottom': _ctx.isLargeScreen }])
        }, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", {
              class: "select-all weui-cells_checkbox",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.selectCurrentPage && _ctx.selectCurrentPage(...args)))
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                class: "g-checkbox checkbox weui-check",
                value: "1",
                checked: _ctx.selectCurrentUnpaid
              }, null, 8, _hoisted_35),
              _hoisted_36,
              _createTextVNode(" 全选 ")
            ]),
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("div", _hoisted_39, "¥" + _toDisplayString(_ctx.selectPackagePrice), 1)
            ]),
            _createElementVNode("div", {
              class: "g-button g-button-danger",
              "hover-class": "hover",
              onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.batchPay && _ctx.batchPay(...args)), ["stop"]))
            }, " 立即支付 ")
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.dialogVisiable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", {
              class: "g-modal-close",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeLogisticsModal && _ctx.closeLogisticsModal(...args)))
            }, [
              _createVNode(_component_Icon, { icon: "btn_cancel" })
            ]),
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, [
                _withDirectives(_createElementVNode("input", {
                  class: "g-input",
                  "cursor-spacing": "100",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.logisticsCode) = $event)),
                  placeholder: "填写购物平台发货的快递单号"
                }, null, 512), [
                  [_vModelText, _ctx.logisticsCode]
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "g-button g-button-primary",
              "hover-class": "hover",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.updateCode && _ctx.updateCode(...args)))
            }, " 保存 ")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showPayment)
      ? (_openBlock(), _createBlock(_component_Payment, {
          key: 2,
          "package-ids": _ctx.payPackageIds,
          onClose: _ctx.closePayment,
          onSuccess: _ctx.paySuccess
        }, null, 8, ["package-ids", "onClose", "onSuccess"]))
      : _createCommentVNode("", true)
  ], 2))
}